// extracted by mini-css-extract-plugin
module.exports = {"root":"LoggedOutHeader_root__9Vk5k","link":"LoggedOutHeader_link__hjuGa","headerBtn":"LoggedOutHeader_headerBtn__DdCrc","startIcon":"LoggedOutHeader_startIcon__oC1MV"};